export const SEVEN_APP_CAPABILITY_MANIFEST_VERSION = "1.0.0";
const READ_ROLES = [
    "super-admin",
    "super-sub-admin",
    "owner",
    "admin",
    "member",
];
const WRITE_ROLES = [
    "super-admin",
    "super-sub-admin",
];
function writeAction(action, method, pathTemplate) {
    return {
        action,
        method,
        pathTemplate,
        approval: { required: true, singleUse: true, expirySeconds: 300 },
        retry: { maxAttempts: 1, automaticReplayAllowed: false },
        idempotency: {
            keySource: "durable_execution_identity",
            providerGuarantee: "unverified",
        },
    };
}
function manifest(appId, displayName, readActions, writeActions) {
    const envId = appId.toUpperCase();
    return {
        appId,
        displayName,
        canonicalAdapter: "server-owned-app-transport.v2",
        capabilityId: `${appId}_controlled_write`,
        config: {
            baseUrlReference: `SMART_SHIKKA_APP_BASE_URL_${envId}`,
            secretReference: `SMART_SHIKKA_APP_SECRET_${envId}`,
            timeoutReference: `SMART_SHIKKA_APP_TIMEOUT_MS_${envId}`,
            healthPath: "/health",
        },
        scopes: {
            owner: true,
            tenant: true,
            project: true,
            read: `apps:${appId}:read`,
            write: `apps:${appId}:write`,
        },
        rolePolicy: {
            read: READ_ROLES,
            write: WRITE_ROLES,
        },
        readActions,
        writeActions,
        evidence: {
            requiredFields: [
                "appId",
                "capabilityId",
                "action",
                "actorId",
                "ownerId",
                "tenantId",
                "projectId",
                "requestId",
                "jobId",
                "payloadHash",
                "runId",
                "taskId",
                "stageId",
                "attemptId",
                "actionDigest",
                "externalId",
                "providerIdempotency",
                "automaticReplayAllowed",
                "approvalRef",
                "downstreamStatus",
                "executionOutcome",
                "realExecutionAttempted",
                "realExecutionVerified",
                "realExecutionPerformed",
            ],
        },
    };
}
const MANIFESTS = [
    manifest("smart_print", "Smart Print", ["accounting", "job-cards", "inventory", "reports"], [writeAction("save-draft", "POST", "/api/smart-shikka/draft-estimate")]),
    manifest("smart_salary", "Smart Salary", ["employees", "attendance", "salary-register", "payroll"], [writeAction("save-draft", "POST", "/api/smart-shikka/attendance-draft")]),
    manifest("drishti_kundli", "Drishti Kundli", ["kundli-form", "matching", "report", "interpretation"], [
        writeAction("save-draft", "POST", "/api/smart-shikka/kundli-draft"),
        writeAction("compensate", "POST", "/api/smart-shikka/kundli-draft"),
        writeAction("rollback", "POST", "/api/smart-shikka/kundli-draft"),
    ]),
    manifest("anshika_api", "Anshika API", ["whatsapp-status", "email-status", "payment-status", "history"], [writeAction("save-draft", "POST", "/api/smart-shikka/message-template-draft")]),
    manifest("smart_ordering_core", "Smart Ordering Core", ["catalog", "orders", "reports", "checkout-status"], [writeAction("update-status", "PUT", "/api/admin/orders/:orderId/status")]),
    manifest("anoopam_press_website", "Anoopam Press Website", ["services", "content", "leads", "publishing-status"], [writeAction("save-draft", "POST", "/api/smart-shikka/lead-draft")]),
    manifest("anshika_website_maker", "Anshika Digital Website Maker", ["templates", "projects", "pages", "domain-status"], [writeAction("save-draft", "POST", "/api/smart-shikka/site-page-draft")]),
];
export function listSevenAppCapabilityManifests() {
    return MANIFESTS;
}
export function getSevenAppCapabilityManifest(appId) {
    return MANIFESTS.find((entry) => entry.appId === appId);
}
export function getSevenAppWriteAction(appId, action) {
    return getSevenAppCapabilityManifest(appId)?.writeActions.find((entry) => entry.action === action);
}
export function getSevenAppCapabilityAvailability(appId, env, environment, verification = {
    runtimeVerified: false,
    liveProven: false,
}) {
    const capability = getSevenAppCapabilityManifest(appId);
    if (!capability)
        throw new Error("unknown_app");
    const baseUrl = env[capability.config.baseUrlReference];
    const secret = env[capability.config.secretReference];
    let validBaseUrl = false;
    if (baseUrl) {
        try {
            const parsed = new URL(baseUrl);
            validBaseUrl =
                parsed.protocol === "https:" &&
                    !parsed.username &&
                    !parsed.password &&
                    parsed.pathname === "/" &&
                    !parsed.search &&
                    !parsed.hash;
        }
        catch {
            validBaseUrl = false;
        }
    }
    const validSecret = typeof secret === "string" && secret.length >= 32;
    const productionApproved = environment !== "production" ||
        env.SMART_SHIKKA_ALLOW_PRODUCTION_APP_EGRESS === "true";
    const unavailableReason = !validBaseUrl
        ? "base_url_not_configured"
        : !validSecret
            ? "secret_not_configured"
            : !productionApproved
                ? "production_egress_not_approved"
                : undefined;
    const configured = unavailableReason === undefined;
    const runtimeVerified = configured && verification.runtimeVerified;
    const liveProven = runtimeVerified && verification.liveProven;
    return {
        appId,
        canonicalAdapter: capability.canonicalAdapter,
        sourceExecutionSupported: true,
        configured,
        health: unavailableReason
            ? "unavailable"
            : runtimeVerified
                ? "available"
                : "configured_unverified",
        runtimeVerified,
        liveProven,
        realExecutionSupported: liveProven,
        ...(unavailableReason ? { unavailableReason } : {}),
        configReferences: capability.config,
    };
}
//# sourceMappingURL=sevenAppCapabilityManifest.js.map